import Api from "./componentApi";
import getRegularPlaceData from "./getRegularPlaceData";
import getAppErrors from "./appErrors";
import setLocalDeliveryData from "./setLocalDeliveryData";

const submitPlace = async (place, route, handleError, userUid) => {
  if (typeof localStorage === "object") {
    localStorage.removeItem("deliveryDetails");
  }
  const lat = place.lat,
    lon = place.lng,
    addresses = place.address,
    isPostalCode = place.isPostalCode;
  const {
    postalCode = "",
    routeName,
    addressLine2,
    flatNumber
  } = await getRegularPlaceData(addresses);
  if (!postalCode) {
    var body = document.body;
    const errorMessage = getAppErrors(8001);
    body.classList.add("body-overflow");
    const message =
      (errorMessage && errorMessage.message) || "Postal code not found";
    handleError(message);
  } else {
    Api.post(
      "/api/route/data",
      { postalCode },
      (postalResponse, postalErros) => {
        if (postalErros) {
          if (postalErros === 503) {
            handleError(503);
          } else {
            console.log(postalErros);
          }
        } else if (postalResponse.code) {
          var body = document.body;
          const errorMessage = getAppErrors(postalResponse.code);
          body.classList.add("body-overflow");
          const message =
            (errorMessage && errorMessage.message) || postalResponse.message;
          handleError(message);
        } else {
          const addressData = {
            lat,
            lon,
            postalCode,
            routeName,
            addressLine2,
            flatNumber,
            delivery: true,
            isPostalCode,
            adminWard:
              (postalResponse.adminWard &&
                postalResponse.adminWard.slugAdminWard) ||
              "",
            adminWardName:
              (postalResponse.adminWard &&
                postalResponse.adminWard.adminWard) ||
              "",
            city: postalResponse.city.slugName
          };
          if (userUid) {
            addressData.uid = userUid;
          }
          const jsonData = JSON.stringify(addressData);
          setLocalDeliveryData(jsonData, () =>
            setDeliveryDataCallback(addressData)
          );
        }
      }
    );
  }
};

const setDeliveryDataCallback = addressData => {
  let href;
  if (addressData.adminWard) {
    href = `/restaurants/${addressData.city}/${addressData.adminWard}/?postcode=${addressData.postalCode}&time=now`;
  } else {
    href = `/restaurants/${addressData.city}/list/?postcode=${addressData.postalCode}&time=now`;
  }
  if (href) {
    window.location.href = href;
  }
};
export default submitPlace;
